/**
 * src/components/HeroCarousel.jsx
 * Edit SLIDES below to change images/copy/links. Background image is
 * blurred; text stays crisp on top of a dark overlay for contrast.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SLIDES = [
  {
    image: "/background-carousel-1.jpg",
    eyebrow: "New Collection",
    title: "Festive ready with Ritu Fashion",
    copy: "Ethnic wear for wedding celebrations, party frocks for birthdays, and adorable styles for every special occasion.",
    ctaText: "Shop Girls →",
    ctaLink: "/shop?gender=girls",
  },
  {
    image: "/background-car-3.jpg",
    eyebrow: "Everyday Comfort",
    title: "Cool, easy styles for boys",
    copy: "Cord-sets for everyday play and stylish suits for wedding celebrations.",
    ctaText: "Shop Boys →",
    ctaLink: "/shop?gender=boys",
  },
];

const ROTATE_MS = 5000;

export function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % SLIDES.length), ROTATE_MS);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="hero-carousel">
      {SLIDES.map((slide, i) => (
        <div key={slide.image} className={`hero-slide ${i === index ? "active" : ""}`}>
          <img src={slide.image} alt="" className="hero-slide-bg" />
          <div className="hero-slide-overlay" />
          <div className="hero-slide-content">
            <span className="pill pill-primary">{slide.eyebrow}</span>
            <h1 className="hero-title">{slide.title}</h1>
            <p className="hero-copy">{slide.copy}</p>
            <Link to={slide.ctaLink} className="btn btn-primary mt-6">{slide.ctaText}</Link>
          </div>
        </div>
      ))}

      <div className="hero-dots">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            aria-label={`Go to slide ${i + 1}`}
            className={`hero-dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>
  );
}